import React, { useEffect, useState } from 'react';
import { Steps } from '../../components/Steps';
import { AuthMethodStep } from './steps/AuthMethodStep';
import { GrantAccessStep } from './steps/GrantAccessStep';
import { ServiceAccountStep } from './steps/ServiceAccountStep';
import { ProjectConfigurationStep } from './steps/ProjectConfigurationStep';
import { TableMappingStep } from './steps/TableMappingStep';
import { ColumnMappingStep } from './steps/ColumnMappingStep';
import { useBigQueryContext } from './contexts/BigQueryContext';
import type { AuthMethod } from './types';

export function BigQueryForm() {
  const { credentials } = useBigQueryContext();
  const [step, setStep] = useState(0);
  const [authMethod, setAuthMethod] = useState<AuthMethod>('oauth');

  // Auto-skip Step 0 if auth method is already decided (re-entering wizard for existing tenant)
  useEffect(() => {
    if (credentials?.auth_type || credentials?.tokens) {
      setAuthMethod(credentials.auth_type ?? 'oauth');
      setStep(1);
    }
  }, []);

  const handleAuthMethodSelect = (selected: AuthMethod) => {
    setAuthMethod(selected);
    setStep(1);
  };

  return (
    <>
      <Steps
        steps={[
          { title: 'Auth method' },
          { title: 'Grant access' },
          { title: 'Project configuration' },
          { title: 'Table Mapping' },
          { title: 'Column Mapping' },
        ]}
        currentStep={step}
        onStepChange={(nextStep) => {
          setStep(nextStep);
        }}
      />
      {step === 0 && <AuthMethodStep nextStep={handleAuthMethodSelect} />}
      {step === 1 && authMethod === 'oauth' && (
        <GrantAccessStep
          nextStep={() => setStep(2)}
          switchToServiceAccount={() => setStep(0)}
        />
      )}
      {step === 1 && authMethod === 'service_account' && (
        <ServiceAccountStep nextStep={() => setStep(2)} />
      )}
      {step === 2 && (
        <ProjectConfigurationStep
          nextStep={() => setStep(3)}
          previousStep={() => setStep(1)}
        />
      )}
      {step === 3 && (
        <TableMappingStep
          previousStep={() => setStep(2)}
          nextStep={() => setStep(4)}
        />
      )}
      {step === 4 && (
        <ColumnMappingStep
          previousStep={() => setStep(3)}
          nextStep={() => setStep(0)}
        />
      )}
    </>
  );
}
